/*
 * Keeps a virtual-carat "adjustment" line item (see culet-pdp-main.liquid) in sync
 * with its paired primary line item, so changing quantity or removing the ring in
 * the cart never leaves an invisible top-up charge behind.
 */
(function () {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    var items = event && event.cartData && event.cartData.items;
    reconcileBundles(items);
  });

  function reconcileBundles(items) {
    if (!items || !items.length) return;

    var bundles = {};
    items.forEach(function (item) {
      var props = item.properties || {};
      var bundleId = props['_bundle_id'];
      if (!bundleId) return;
      bundles[bundleId] = bundles[bundleId] || {};
      if (props['_bundle_role'] === 'primary') bundles[bundleId].primary = item;
      if (props['_bundle_role'] === 'adjustment') bundles[bundleId].adjustment = item;
    });

    var corrections = [];
    Object.keys(bundles).forEach(function (bundleId) {
      var bundle = bundles[bundleId];

      if (!bundle.primary && bundle.adjustment) {
        corrections.push({ id: bundle.adjustment.key, quantity: 0 });
        return;
      }
      if (bundle.primary && bundle.adjustment) {
        var perUnit = parseFloat(bundle.primary.properties['_bundle_amount'] || '0');
        var expectedQty = Math.round(perUnit * bundle.primary.quantity);
        if (bundle.adjustment.quantity !== expectedQty) {
          corrections.push({ id: bundle.adjustment.key, quantity: expectedQty });
        }
      }
    });

    if (corrections.length) runCorrections(corrections);
  }

  function runCorrections(corrections) {
    corrections
      .reduce(function (chain, correction) {
        return chain.then(function () { return applyCorrection(correction); });
      }, Promise.resolve())
      .catch(function (e) { console.error('Carat bundle reconciliation failed', e); });
  }

  function applyCorrection(correction) {
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionDescriptors = cartDrawer && cartDrawer.getSectionsToRender
      ? cartDrawer.getSectionsToRender()
      : [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];

    return fetch(routes.cart_change_url, {
      ...fetchConfig(),
      body: JSON.stringify({
        id: correction.id,
        quantity: correction.quantity,
        sections: sectionDescriptors.map(function (s) { return s.id; }),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (parsedState) {
        if (!parsedState.errors) patchSections(parsedState.sections, sectionDescriptors);
      });
  }

  // Patches section HTML in place without opening the drawer — this runs silently
  // in the background, not in response to the shopper looking at their cart.
  function patchSections(sections, descriptors) {
    if (!sections) return;
    descriptors.forEach(function (section) {
      var html = sections[section.id];
      if (!html) return;
      var target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!target) return;
      var parsed = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(section.selector || '.shopify-section');
      if (parsed) target.innerHTML = parsed.innerHTML;
    });
  }
})();
